const pendingListboxTypeahead = new WeakMap();
const listboxesWithSearchHistory = new WeakSet();

export function openAdmin2026ListboxWithTypeahead(event, nextTick) {
    const button = event && event.currentTarget;
    const key = event && typeof event.key === 'string' ? event.key : '';

    if (!button
        || key.length !== 1
        || key === ' '
        || event.defaultPrevented
        || event.isComposing
        || event.altKey
        || event.ctrlKey
        || event.metaKey
        || button.disabled
        || button.getAttribute('aria-disabled') === 'true') {
        return false;
    }

    event.preventDefault();
    event.stopPropagation();

    const pending = pendingListboxTypeahead.get(button) || {
        keys: [],
        scheduled: false,
    };
    pending.keys.push({
        key,
        code: event.code || '',
        shiftKey: !!event.shiftKey,
    });
    pendingListboxTypeahead.set(button, pending);

    if (button.getAttribute('aria-expanded') !== 'true') {
        button.click();
    }

    if (pending.scheduled) {
        return true;
    }

    pending.scheduled = true;

    const schedule = typeof nextTick === 'function'
        ? nextTick
        : (callback) => Promise.resolve().then(callback);

    schedule(() => {
        const view = button.ownerDocument && button.ownerDocument.defaultView;
        const requestFrame = view && typeof view.requestAnimationFrame === 'function'
            ? view.requestAnimationFrame.bind(view)
            : (callback) => setTimeout(callback, 0);

        requestFrame(() => requestFrame(() => requestFrame(() => {
            const optionsId = button.getAttribute('aria-controls');
            const options = optionsId && button.ownerDocument
                ? button.ownerDocument.getElementById(optionsId)
                : button.parentElement && button.parentElement.querySelector('[role="listbox"]');

            if (!options) {
                pendingListboxTypeahead.delete(button);
                return;
            }

            const KeyboardEventConstructor = view && view.KeyboardEvent
                ? view.KeyboardEvent
                : KeyboardEvent;

            if (typeof options.focus === 'function') {
                options.focus({ preventScroll: true });
            }

            if (listboxesWithSearchHistory.has(button)) {
                const selectedOption = options.querySelector('[role="option"][aria-selected="true"]:not([aria-disabled="true"])');

                if (selectedOption && typeof selectedOption.focus === 'function') {
                    selectedOption.focus({ preventScroll: true });
                    options.focus({ preventScroll: true });
                } else {
                    // Headless UI retains an unfinished search when the listbox
                    // closes quickly. Home clears that private search state.
                    options.dispatchEvent(new KeyboardEventConstructor('keydown', {
                        key: 'Home',
                        code: 'Home',
                        bubbles: true,
                        cancelable: true,
                        composed: true,
                    }));
                }
            }

            const dispatchNextKey = () => {
                const pendingKey = pending.keys.shift();

                if (!pendingKey) {
                    pendingListboxTypeahead.delete(button);
                    return;
                }

                options.dispatchEvent(new KeyboardEventConstructor('keydown', {
                    key: pendingKey.key,
                    code: pendingKey.code,
                    bubbles: true,
                    cancelable: true,
                    composed: true,
                    shiftKey: pendingKey.shiftKey,
                }));
                listboxesWithSearchHistory.add(button);

                requestFrame(dispatchNextKey);
            };

            requestFrame(dispatchNextKey);
        })));
    });

    return true;
}
